import { z } from "zod";
import { UserSchema } from "./User";

export const DocumentOrderFieldsSchema = z.object({
  id: z.number().int(),
  valueNettoBeforeDiscount: z.number(),
  valueNetto: z.number(),
  createdAt: z.string(),
  documentHeader: z.string(),
  documentStatus: z.number().int(),
  valueBrutto: z.number(),
  notes: z.string(),
  importId: z.string(),
  importCode: z.string(),
  importTyp: z.string(),
  addressCustomer: z.string(),
  addressDelivery: z.string(),
  externalNumber: z.string(),
  externalDate: z.string(),
  dateDelivery: z.string(),
  orderType: z.number(),
  companyName: z.string(),
  defaultAddress: z.string(),
  nip: z.string(),
  userPhName: z.string(),
  currencyCode: z.string(),
  exchange: z.any(),
  exchangeRatio: z.number(),
  modificationDate: z.string(),
});
export const PartialDocumentOrderFieldsSchema =
  DocumentOrderFieldsSchema.deepPartial();

export const DocumentOrderExtraFieldsSchema = z.object({
  attributes: z.array(z.any()),
  creator: UserSchema,
});
export const PartialDocumentOrderExtraFieldsSchema =
  DocumentOrderExtraFieldsSchema.deepPartial();

export const DocumentOrderSchema = z.intersection(
  DocumentOrderFieldsSchema,
  DocumentOrderExtraFieldsSchema
);

export type DocumentOrderFields = z.infer<typeof DocumentOrderFieldsSchema>;
export type PartialDocumentOrderFields = z.infer<
  typeof PartialDocumentOrderFieldsSchema
>;
export type DocumentOrderExtraFields = z.infer<
  typeof DocumentOrderExtraFieldsSchema
>;
export type PartialDocumentOrderExtraFields = z.infer<
  typeof PartialDocumentOrderExtraFieldsSchema
>;
export type DocumentOrder = z.infer<typeof DocumentOrderSchema>;
